import { parseISO8601 } from "../iso8601";
import {
  CellTextBoxDot,
  narrowCellsFrench,
  safeString,
  safeZero,
  styles,
} from "../reportingHelpers";
import { View } from "@react-pdf/renderer";
import React from "react";

export const TotalsBoxScoreReportRow = ({
  row,
  index,
  isTotalsRow = false,
  intl,
  personStats,
  teamStats,
  teamStatsPeriods,
  rowLabel,
  efficiency,
  plusMinus,
}) => {
  let dnp = false;
  const minutesArray = [];
  teamStatsPeriods.forEach((r) => {
    let parsedMinutes = {};
    if (r && r.minutes) {
      parsedMinutes = parseISO8601(r.minutes);
      if (parsedMinutes.minutes === 0 && parsedMinutes.seconds === 0) {
        dnp = true;
      }
    }
    minutesArray.push(parsedMinutes);
  });
  const minutes = minutesArray.reduce((acc, stats) => acc + stats.minutes, 0);

  function getTotalSum(propertyName) {
    return row.reduce((acc, stats) => acc + stats[propertyName], 0);
  }

  return (
    <View
      style={{
        ...styles.tableRowFrench,
        backgroundColor: "white",
      }}
    >
      {
        <React.Fragment>
          {!isTotalsRow && !rowLabel && (
            <React.Fragment>
              <CellTextBoxDot
                noDot={true}
                style={{ borderRightColor: "white" }}
              >
                {row.bib ?? " "}
              </CellTextBoxDot>
              <CellTextBoxDot style={{ textAlign: "left", paddingLeft: 2 }}>
                {safeString(row, "personFullName")}
              </CellTextBoxDot>
              <CellTextBoxDot noDot={true}>
                {row.starter ? "#" : ""}
              </CellTextBoxDot>
            </React.Fragment>
          )}
          {(isTotalsRow || rowLabel) && (
            <React.Fragment>
              <CellTextBoxDot
                style={{
                  textAlign: "left",
                  paddingLeft: 2,
                  width: "36.8mm",
                  fontWeight: "bold",
                  borderRightColor: "white",
                }}
              >
                {rowLabel
                  ? rowLabel
                  : intl.formatMessage({
                      id: "reports.boxscore.table.totals",
                      defaultMessage: "Totals",
                    })}
              </CellTextBoxDot>
              <CellTextBoxDot
                noDot={true}
                style={{ width: "4mm", borderRightColor: "white" }}
              >
                {" "}
              </CellTextBoxDot>
            </React.Fragment>
          )}
          <CellTextBoxDot
            noDot={true}
            style={{ width: "9mm", borderLeftWidth: 0 }}
          >
            {isTotalsRow ? minutes : ""}
          </CellTextBoxDot>
          <CellTextBoxDot noDot={true} style={{ width: "6mm" }}>
            {!dnp && getTotalSum("points")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm", borderRightColor: "white" }}>
            {!dnp &&
              getTotalSum("fieldGoalsMade") +
                "/" +
                getTotalSum("fieldGoalsAttempted")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {!dnp && getTotalSum("fieldGoalsAttempted")
              ? (
                  100 *
                  (getTotalSum("fieldGoalsMade") /
                    getTotalSum("fieldGoalsAttempted"))
                ).toFixed(0)
              : "."}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm", borderRightColor: "white" }}>
            {!dnp &&
              getTotalSum("pointsThreeMade") +
                "/" +
                getTotalSum("pointsThreeAttempted")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {!dnp && getTotalSum("pointsThreeAttempted")
              ? (
                  100 *
                  (getTotalSum("pointsThreeMade") /
                    getTotalSum("pointsThreeAttempted"))
                ).toFixed(0)
              : "."}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm", borderRightColor: "white" }}>
            {!dnp &&
            getTotalSum("pointsTwoAttempted") -
              getTotalSum("pointsInThePaintAttempted")
              ? getTotalSum("pointsTwoMade") -
                getTotalSum("pointsInThePaintMade") +
                "/" +
                (getTotalSum("pointsTwoAttempted") -
                  getTotalSum("pointsInThePaintAttempted"))
              : "."}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {!dnp &&
            getTotalSum("pointsTwoAttempted") -
              getTotalSum("pointsInThePaintAttempted")
              ? (
                  (100 *
                    (getTotalSum("pointsTwoMade") -
                      getTotalSum("pointsInThePaintMade"))) /
                  (getTotalSum("pointsTwoAttempted") -
                    getTotalSum("pointsInThePaintAttempted"))
                ).toFixed(0)
              : "."}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm", borderRightColor: "white" }}>
            {!dnp && getTotalSum("pointsInThePaintAttempted")
              ? getTotalSum("pointsInThePaintMade") +
                "/" +
                getTotalSum("pointsInThePaintAttempted")
              : "."}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {!dnp && getTotalSum("pointsInThePaintAttempted")
              ? (
                  (100 * getTotalSum("pointsInThePaintMade")) /
                  getTotalSum("pointsInThePaintAttempted")
                ).toFixed(0)
              : "."}
          </CellTextBoxDot>

          <CellTextBoxDot style={{ width: "6mm" }}>
            {!dnp && getTotalSum("dunks")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm", borderRightColor: "white" }}>
            {!dnp &&
              getTotalSum("freeThrowsMade") +
                "/" +
                getTotalSum("freeThrowsAttempted")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {!dnp && getTotalSum("freeThrowsAttempted")
              ? (
                  100 *
                  (getTotalSum("freeThrowsMade") /
                    getTotalSum("freeThrowsAttempted"))
                ).toFixed(0)
              : "."}
          </CellTextBoxDot>

          <CellTextBoxDot
            style={{ ...narrowCellsFrench, borderRightColor: "white" }}
          >
            {getTotalSum("foulsTotal")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {!dnp && getTotalSum("foulsDrawn")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {!dnp && safeZero(row, "blocks")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {!dnp && safeZero(row, "blocksReceived")}
          </CellTextBoxDot>

          <CellTextBoxDot
            style={{ ...narrowCellsFrench, borderRightColor: "white" }}
          >
            {!dnp && getTotalSum("reboundsOffensive")}
          </CellTextBoxDot>
          <CellTextBoxDot
            style={{ ...narrowCellsFrench, borderRightColor: "white" }}
          >
            {!dnp && getTotalSum("reboundsDefensive")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {!dnp && getTotalSum("rebounds")}
          </CellTextBoxDot>

          <CellTextBoxDot
            style={{ ...narrowCellsFrench, borderRightColor: "white" }}
          >
            {!dnp && getTotalSum("steals")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {!dnp && getTotalSum("turnovers")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {!dnp && getTotalSum("assists")}
          </CellTextBoxDot>

          <CellTextBoxDot style={{ width: "7mm" }}>
            {!dnp && efficiency ? efficiency : getTotalSum("efficiency")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ ...narrowCellsFrench, borderRightWidth: 1 }}>
            {!dnp && plusMinus ? plusMinus : getTotalSum("plusMinus")}
          </CellTextBoxDot>
        </React.Fragment>
      }
    </View>
  );
};
